import * as React from "react";

function SvgEmma(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 498.11 165.28"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <defs>
        <linearGradient
          id="EMMA_svg__a"
          x1={118.72}
          y1={82.17}
          x2={360.61}
          y2={82.17}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#12849f" />
          <stop offset={1} stopColor="#00a263" />
        </linearGradient>
      </defs>
      <path
        d="M480.44 139.47l-9.89-23.89h3.82a4.5 4.5 0 000-9h-7.54l-35.08-84.75a4.49 4.49 0 00-4.15-2.78 4.5 4.5 0 00-4.16 2.77l-36.29 87.23a4.6 4.6 0 00-.25.61l-12.4 29.8a4.5 4.5 0 008.31 3.46l11.37-27.34h66.63l11.31 27.33a4.5 4.5 0 108.32-3.44zm-82.52-32.89l29.66-71.29 29.5 71.29z"
        fill="#00a263"
      />
      <path
        d="M356.11 145.69a4.5 4.5 0 01-4.5-4.5V35.08l-50.44 57.31a4.49 4.49 0 01-6.22.52l-50.79-41.45v89.73a4.5 4.5 0 01-9 0V53.85l-50.44 57a4.51 4.51 0 01-6.29.44l-50.71-43.12v73a4.5 4.5 0 01-9 0V58.45a4.49 4.49 0 017.41-3.45l54.77 46.52L236.29 39a4.52 4.52 0 016.22-.51l54.77 44.7 55.45-63a4.5 4.5 0 017.88 3v118a4.51 4.51 0 01-4.5 4.5z"
        fill="url(#EMMA_svg__a)"
      />
      <path
        d="M102 136.69H35.09v-41h38.58a4.5 4.5 0 000-9H35.09v-59h67a4.5 4.5 0 000-9h-71.5a4.49 4.49 0 00-4.5 4.5v63.48h-3.73a4.5 4.5 0 000 9h3.73v45.52a4.5 4.5 0 004.5 4.5H102a4.5 4.5 0 100-9z"
        fill="#12849f"
      />
    </svg>
  );
}

export default React.forwardRef(SvgEmma);
